import { defineStore } from "pinia";
type bannerType = "card" | "";
interface AppState {
  logo: boolean;
  fixedHeader: boolean;
  greyMode: boolean;
  pageLoading: boolean;
  title: string;
  mobile: boolean;
  footer: boolean;
  theme: ThemeTypes;
  headerHeight: number;
  headerShow: boolean;
  bannerType: bannerType;
  bannerCount: number;
  pageHeader: number;
}

export const useAppStore = defineStore("app", {
  state: (): AppState => ({
    // 是否是移动端
    mobile: false,
    // 头部高度
    headerHeight: 60,
    // 固定toolheader
    fixedHeader: true,
    // 显示header
    headerShow: true,

    bannerType: "",
    bannerCount: 0,
    pageHeader: 0,
    // 标题
    title: import.meta.env.VITE_APP_TITLE,
    // 路由跳转loading
    pageLoading: false,
    // logo
    logo: true,
    // 显示页脚
    footer: true,
    // 是否开始灰色模式，用于特殊悼念日
    greyMode: false,
    theme: {
      // 主题色
      elColorPrimary: "#409eff",
      // 左侧菜单边框颜色
      leftMenuBorderColor: "#eee",
      // 左侧菜单背景颜色
      leftMenuBgColor: "#fff",
      // 左侧菜单浅色背景颜色
      leftMenuBgLightColor: "#fff",
      // 左侧菜单选中背景颜色
      leftMenuBgActiveColor: "RGBA(64,158,255,0.1)",
      // 左侧菜单收起选中背景颜色
      leftMenuCollapseBgActiveColor: "RGBA(64,158,255,0.1)",
      // 左侧菜单字体颜色
      leftMenuTextColor: "#333",
      // 左侧菜单选中字体颜色
      leftMenuTextActiveColor: "var(--el-color-primary)",
      // logo字体颜色
      logoTitleTextColor: "inherit",
      // logo边框颜色
      logoBorderColor: "#eee",
      // 头部背景颜色
      topHeaderBgColor: "#fff",
      // 头部字体颜色
      topHeaderTextColor: "inherit",
      // 头部悬停颜色
      topHeaderHoverColor: "#f6f6f6",
      // 头部边框颜色
      topToolBorderColor: "#eee",
    },
  }),
  getters: {
    getMobile(): boolean {
      return this.mobile;
    },
    getPageHeader(): number {
      return this.pageHeader;
    },
    getBannerType(): bannerType {
      return this.bannerType;
    },
    getBannerCount(): number {
      return this.bannerCount;
    },
    getHeaderShow(): boolean {
      return this.headerShow;
    },
    getHeaderHeight(): number {
      return this.headerHeight;
    },
    getTitle(): string {
      return this.title;
    },
    getPageLoading(): boolean {
      return this.pageLoading;
    },
    getLogo(): boolean {
      return this.logo;
    },
    getFixedHeader(): boolean {
      return this.fixedHeader;
    },
    getFooter(): boolean {
      return this.footer;
    },
    getGreyMode(): boolean {
      return this.greyMode;
    },
    getTheme(): ThemeTypes {
      return this.theme;
    },
  },
  actions: {
    setTitle(title: string) {
      this.title = title;
    },
    setBannerCount(num: number) {
      this.bannerCount = num;
    },
    setBannerType(type: bannerType) {
      this.bannerType = type;
    },
    setLogo(logo: boolean) {
      this.logo = logo;
    },
    setPageHeader(num: number) {
      this.pageHeader = num;
    },
    setHeaderShow(headerShow: boolean) {
      this.headerShow = headerShow;
    },
    setHeaderHeight(headerHeight: number) {
      this.headerHeight = headerHeight;
    },
    setGreyMode(greyMode: boolean) {
      this.greyMode = greyMode;
    },
    setFooter(footer: boolean) {
      this.footer = footer;
    },
    setFixedHeader(fixedHeader: boolean) {
      this.fixedHeader = fixedHeader;
    },
    setPageLoading(pageLoading: boolean) {
      this.pageLoading = pageLoading;
    },
    setMobile(mobile: boolean) {
      this.mobile = mobile;
    },
    setTheme(theme: ThemeTypes) {
      this.theme = Object.assign(this.theme, theme);
    },
  },
});
